import React, { useState, useMemo } from 'react';
import { PRODUCTS, CATEGORIES } from '../mock';
import ProductQuickView from './ProductQuickView';

function ProductCard({ p, onOpen }) {
  return (
    <div className="group cursor-pointer" onClick={() => onOpen(p)}>
      <div className="relative overflow-hidden bg-stone-100 aspect-[3/4]">
        <img
          src={p.image}
          alt={p.name}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          onError={(e) => { e.currentTarget.style.opacity = 0.3; }}
        />
        <span className="absolute top-3 left-3 bg-[#f7f2ec]/90 backdrop-blur-sm text-[10px] tracking-[0.22em] uppercase px-2.5 py-1 text-stone-800">
          {p.category}
        </span>
        <div
          className="absolute inset-x-3 bottom-3 py-3 bg-stone-900 text-[#f7f2ec] text-[11px] tracking-[0.24em] uppercase text-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:bg-stone-800"
        >
          İncele & Sepete Ekle
        </div>
      </div>
      <div className="mt-4 flex items-start justify-between gap-2">
        <h3 className="font-serif text-[17px] text-stone-900 leading-tight">{p.name}</h3>
        <p className="text-stone-800 whitespace-nowrap">₺{p.price.toLocaleString('tr-TR')}</p>
      </div>
      <p className="mt-1 text-[11px] tracking-[0.18em] uppercase text-stone-500">
        {p.colors.length} renk · {p.sizes.length} beden
      </p>
    </div>
  );
}

export default function Collection() {
  const [active, setActive] = useState('Tümü');
  const [visible, setVisible] = useState(12);
  const [selected, setSelected] = useState(null);

  const filtered = useMemo(() => {
    if (active === 'Tümü') return PRODUCTS;
    return PRODUCTS.filter((p) => p.category === active);
  }, [active]);

  const shown = filtered.slice(0, visible);

  return (
    <section id="koleksiyon" className="bg-[#f7f2ec] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-3">
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-stone-500">Koleksiyon</p>
            <h2 className="mt-3 font-serif text-4xl lg:text-6xl text-stone-900 leading-none">
              Tüm <em className="italic font-light">koleksiyon</em>
            </h2>
          </div>
          <p className="text-[13px] text-stone-600">
            {PRODUCTS.length} model · {PRODUCTS.length} farklı parça
          </p>
        </div>

        <div className="mt-10 flex flex-wrap gap-2 border-b border-stone-200 pb-6">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => { setActive(c); setVisible(12); }}
              className={`px-4 py-2 text-[11px] tracking-[0.22em] uppercase transition-colors border ${
                active === c
                  ? 'bg-stone-900 text-[#f7f2ec] border-stone-900'
                  : 'bg-transparent text-stone-700 border-stone-300 hover:border-stone-900 hover:text-stone-900'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
          {shown.map((p) => (
            <ProductCard key={p.id} p={p} onOpen={setSelected} />
          ))}
        </div>

        {visible < filtered.length && (
          <div className="mt-14 flex justify-center">
            <button
              onClick={() => setVisible((v) => v + 12)}
              className="px-8 py-3.5 border border-stone-900 text-[11px] tracking-[0.24em] uppercase text-stone-900 hover:bg-stone-900 hover:text-[#f7f2ec] transition-colors"
            >
              Daha Fazla Göster ({filtered.length - visible})
            </button>
          </div>
        )}
      </div>

      {selected && <ProductQuickView product={selected} onClose={() => setSelected(null)} />}
    </section>
  );
}
